export const DISABLE_TOP_YMAL_PDP = 'disableTopYmalPdp';
export const MW_MW_PDP_SHIFTS = 'MW_PDP_Shifts_JAN25';
export const PDP_DESKTOP_AGGREGATION_FEB_2025 = 'PDPDesktopAggregation_Feb2025';
export const PDP_MWUX_REDESIGN = 'PDP_MWUXRedesign_Sept2025';
export const PDP_SELLER_REVIEWS = 'PDP_SellerReviews_Nov2025';
export const PDP_ESTIMATE_SIMILAR_SOLD_TEST_NAME = 'PDP_1stDibsEstimateSimilarSold_Oct2025';
